import { render, staticRenderFns } from "./AppleLoginComponent.vue?vue&type=template&id=02489d2b&scoped=true"
import script from "./AppleLoginComponent.vue?vue&type=script&lang=js"
export * from "./AppleLoginComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02489d2b",
  null
  
)

export default component.exports